shadow$provide[288] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Transpose:{enumerable:true, get:function() {
  return Transpose;
}}});
var UGLSL = require("../../../util/glsl.js");
var require$_DOT__SLASH_operator_DOT_js = require("./operator.js");
const labels = {1:"width", 2:"height", 3:"depth", 4:"items",};
class Transpose extends require$_DOT__SLASH_operator_DOT_js.Operator {
  static initClass() {
    this.traits = ["node", "bind", "operator", "source", "index", "transpose"];
  }
  indexShader(shader) {
    if (this.swizzler) {
      shader.pipe(this.swizzler);
    }
    return super.indexShader(shader);
  }
  sourceShader(shader) {
    if (this.swizzler) {
      shader.pipe(this.swizzler);
    }
    return super.sourceShader(shader);
  }
  getDimensions() {
    return this._remap(this.transpose, this.bind.source.getDimensions());
  }
  getActiveDimensions() {
    return this._remap(this.transpose, this.bind.source.getActiveDimensions());
  }
  getFutureDimensions() {
    return this._remap(this.transpose, this.bind.source.getFutureDimensions());
  }
  getIndexDimensions() {
    return this._remap(this.transpose, this.bind.source.getIndexDimensions());
  }
  _remap(transpose, dims) {
    const out = {};
    for (let i = 0; i <= 3; i++) {
      const dst = labels[i + 1];
      const src = labels[transpose[i]];
      out[dst] = dims[src] != null ? dims[src] : 1;
    }
    return out;
  }
  make() {
    super.make();
    if (this.bind.source == null) {
      return;
    }
    const {order} = this.props;
    if (order.join() !== "1234") {
      this.swizzler = UGLSL.invertSwizzleVec4(order);
    }
    this.transpose = order;
    return this.trigger({type:"source.rebuild",});
  }
  unmake() {
    super.unmake();
    return this.swizzler = null;
  }
  change(changed, touched, _init) {
    if (touched["transpose"] || touched["operator"]) {
      return this.rebuild();
    }
  }
}
Transpose.initClass();

};